import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { ProductInventoryDto, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    reason?: "warehouseChanged";
};

type Props = {};

type HandlerType = Handler<Parameter, Props>;

export const BeginReloadQuickOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/QuickOrder/BeginReloadInventory",
    });
};

export const ReloadPricingAndInventory: HandlerType = async props => {
    const productInfos = props.getState().pages.quickOrder.productInfos;

    if (!productInfos || productInfos.length === 0) {
        return;
    }

    let pricingLoaded = false;
    let inventoryLoaded = false;

    let pricingResults: ProductPriceDto[] | undefined;
    let inventoryResults: ProductInventoryDto[] | undefined;

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: productInfos.map(p => ({
                productId: p.productId,
                unitOfMeasure: p.unitOfMeasure,
                qtyOrdered: p.qtyOrdered,
            })),
            onComplete: result => {
                pricingResults = result.apiResult?.realTimePricingResults ?? undefined;
                pricingLoaded = true;
            },
        }),
    );

    props.dispatch(
        loadRealTimeInventory({
            productIds: productInfos.map(p => p.productId),
            onComplete: result => {
                inventoryResults = result.apiResult?.realTimeInventoryResults ?? undefined;
                inventoryLoaded = true;
            },
        }),
    );

    await waitFor(() => pricingLoaded && inventoryLoaded);

    for (const existing of productInfos) {
        const updatedProductInfo: ProductInfo = {
            ...existing,
            pricing: pricingResults?.find(p => p.productId === existing.productId),
            inventory: inventoryResults?.find(i => i.productId === existing.productId),
        };

        props.dispatch({
            type: "Pages/QuickOrder/CompleteAddProduct",
            productInfo: updatedProductInfo,
        });
    }
};

export const CompleteReloadQuickOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/QuickOrder/CompleteReloadInventory",
    });
};

export const chain = [
    BeginReloadQuickOrder,
    ReloadPricingAndInventory,
    CompleteReloadQuickOrder,
];

const reloadQuickOrderInventory = createHandlerChainRunner(
    chain,
    "ReloadQuickOrderInventory",
);

export default reloadQuickOrderInventory;